import { render } from "./FirmwareAdd.vue?vue&type=template&id=65dc682c&scoped=true"
import script from "./FirmwareAdd.vue?vue&type=script&lang=js"
export * from "./FirmwareAdd.vue?vue&type=script&lang=js"

import "./FirmwareAdd.vue?vue&type=style&index=0&id=65dc682c&lang=scss&scoped=true"
import "../assets/css/firmwareAdd.css?vue&type=style&index=1&id=65dc682c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65dc682c"]])

export default __exports__